import React from "react";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import styled from "styled-components";
import { ThemeSwitcher } from "../ThemeSwitcher";

function GoUp({ active, scrollUp }) {
  const themesColor = React.useContext(ThemeSwitcher);

  return (
    <Container onClick={scrollUp}>
      <ArrowUpwardIcon
        width={500}
        className={active ? "arrow active" : "arrow"}
      />
    </Container>
  );
}

export default GoUp;

const Container = styled.div`
  svg {
    font-size: 40px;
    background: ${(themesColor) => themesColor.theme.url};
    border-radius: 10px;
    transition: background .3s ease-in-out 0s;
    &:hover {
      transition: all .3s ease-in 0s;
      background: ${(themesColor) => themesColor.theme.title};
    }
    @media (max-width: 768px) {
      display: none;
    }
  }
  .arrow {
    opacity: 0;
    cursor: pointer;
    position: fixed;
    color: ${(themesColor) => themesColor.theme.back};
    bottom: 70px;
    right: 50px;
    animation: arrowGo .3s ease-in-out;
    
    &.active {
      opacity: 1;
      @keyframes arrowGo {
        0% {
          opacity: 1;
          right: 0;
        }
        99% {
          opacity: 1;
          right: 50px;
        }
      }
    }
  }
`;
